import React from 'react';
import { api } from '../services/api';
import { useApi } from '../hooks/useApi';
import Topbar from '../components/Topbar';
import StatCard from '../components/StatCard';
import PredictionsChart from '../components/PredictionsChart';
import LstmForecastChart from '../components/LstmForecastChart';
import ActivityMap from '../components/ActivityMap';
import Panel from '../components/Panel';
import { IconForecast, IconTrendUp, IconPulse } from '../components/icons';

export default function Predictions() {
  const { loading, data, live } = useApi(() => api.predictions());
  const map = useApi(() => api.activityMap());
  const fc = useApi(() => api.forecast());
  const hasLstm = (fc.data?.series || []).length > 0;
  const pts = data?.predictions || [];
  const vals = pts.map((p) => p.flux_prevu);
  const peak = pts.reduce((m, p) => (p.flux_prevu > (m?.flux_prevu ?? -1) ? p : m), null);
  const low = pts.reduce((m, p) => (p.flux_prevu < (m?.flux_prevu ?? 1e9) ? p : m), null);
  const avg = vals.length ? Math.round(vals.reduce((a, b) => a + b, 0) / vals.length) : 0;
  const fmt = (n) => n?.toLocaleString('fr-FR');

  return (
    <>
      <Topbar title="Prévision des flux · 24 h" subtitle="Modèle LSTM (Dataset 1) + profil horaire par zone" live={live} />
      <div className="content">
        {loading ? <div className="loading-screen">Chargement…</div> : (
          <>
            <div className="kpi-row kpi-row--3">
              <StatCard label="Pic prévu" value={fmt(peak?.flux_prevu)} icon={IconTrendUp} trend={{ dir: 'up', text: `à ${peak?.heure}` }} delay={0} />
              <StatCard label="Creux prévu" value={fmt(low?.flux_prevu)} icon={IconPulse} trend={{ dir: 'flat', text: `à ${low?.heure}` }} delay={70} />
              <StatCard label="Moyenne horaire" value={fmt(avg)} icon={IconForecast} delay={140} />
            </div>
            {hasLstm && (
              <div style={{ marginBottom: 18 }}><LstmForecastChart data={fc.data} delay={90} /></div>
            )}
            {map.data?.zones?.length > 0 && (
              <div style={{ marginBottom: 18 }}><ActivityMap data={map.data} /></div>
            )}
            <PredictionsChart data={data} delay={120} />
            <Panel icon={IconForecast} title="Détail horaire" sub={`Zone ${data?.zone_id || '—'}`} delay={200}>
              <table className="tbl">
                <thead><tr><th>Heure</th><th className="num">Flux prévu</th><th>Niveau</th></tr></thead>
                <tbody>
                  {pts.filter((_, i) => i % 2 === 0).map((p) => {
                    const ratio = p.flux_prevu / (peak?.flux_prevu || 1);
                    const tag = ratio > 0.75 ? ['tag--red', 'élevé'] : ratio > 0.4 ? ['tag--amber', 'modéré'] : ['tag--green', 'faible'];
                    return (
                      <tr key={p.heure}>
                        <td className="mono">{p.heure}</td>
                        <td className="num mono">{fmt(p.flux_prevu)}</td>
                        <td><span className={`tag ${tag[0]}`}>{tag[1]}</span></td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </Panel>
          </>
        )}
      </div>
    </>
  );
}
